/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ContactDetails
 */
export interface ContactDetails {
    /**
     *
     * @type {string}
     * @memberof ContactDetails
     */
    name?: string;
    /**
     *
     * @type {string}
     * @memberof ContactDetails
     */
    phoneNumber?: string;
    /**
     *
     * @type {string}
     * @memberof ContactDetails
     */
    email?: string;
    /**
     *
     * @type {string}
     * @memberof ContactDetails
     */
    contactType?: ContactDetailsContactTypeEnum;
}

/**
 * @export
 */
export const ContactDetailsContactTypeEnum = {
    Site: "Site",
    User: "User",
    Other: "Other",
} as const;
export type ContactDetailsContactTypeEnum =
    (typeof ContactDetailsContactTypeEnum)[keyof typeof ContactDetailsContactTypeEnum];

/**
 * Check if a given object implements the ContactDetails interface.
 */
export function instanceOfContactDetails(
    value: object,
): value is ContactDetails {
    return true;
}

export function ContactDetailsFromJSON(json: any): ContactDetails {
    return ContactDetailsFromJSONTyped(json, false);
}

export function ContactDetailsFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): ContactDetails {
    if (json == null) {
        return json;
    }
    return {
        name: json["name"] == null ? undefined : json["name"],
        phoneNumber:
            json["phoneNumber"] == null ? undefined : json["phoneNumber"],
        email: json["email"] == null ? undefined : json["email"],
        contactType:
            json["contactType"] == null ? undefined : json["contactType"],
    };
}

export function ContactDetailsToJSON(value?: ContactDetails | null): any {
    if (value == null) {
        return value;
    }
    return {
        name: value["name"],
        phoneNumber: value["phoneNumber"],
        email: value["email"],
        contactType: value["contactType"],
    };
}
